import { FC } from "react"

// components
import { FooterBase, FooterNavCopy } from "./FooterBase"

// utils
import { events } from "../../utils/heap/tracking_events"

// styles
// @ts-expect-error typed-scss-modules generates `edsLMarTop_4`; webpack css-loader exports `edsLMarTop4`. See README "Stylesheets".
import { edsLMarTop4 } from "../../theme/global.module.scss"
import {
  globalFooter,
  footerHeading,
  footerInnerContainer,
  footerLi,
  footerColumnSection,
  footerLinks
} from "./Footer.module.scss"
import { Typography } from "@eventbrite/marmalade"

export type FooterCopy = NonNullable<
  Queries.HomepageDataQuery["contentfulFooter"]
>["footerReference"]

type Props = {
  footerCopy: FooterCopy
  footerNavCopy: FooterNavCopy
}

export const Footer: FC<Props> = ({ footerCopy, footerNavCopy }) => {
  return (
    <footer className={globalFooter}>
      <div>
        <div className={footerInnerContainer}>
          <div className={footerColumnSection}>
            {footerCopy?.map((footerLink, i) => {
              if (!footerLink) return null
              return (
                <ul key={`${footerLink}__${i}`}>
                  <li>
                    <h3 className={footerHeading}>{footerLink.displayText}</h3>
                  </li>
                  <li>
                    <div className={edsLMarTop4} />
                  </li>
                  <li className={footerLi}>
                    <ul>
                      {footerLink.FooterNavigationChildItems?.map(
                        (childItem, i) => {
                          if (!childItem) return null
                          const { displayText, footerNavigationUrl } = childItem
                          const navUrl = footerNavigationUrl ?? ""
                          return (
                            <li
                              key={`${displayText}__${i}`}
                              className={footerLinks}
                            >
                              <a
                                href={navUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={(e) => {
                                  events?.footerLinkClick(
                                    `${displayText} - ${encodeURI(navUrl)}`,
                                    Footer?.name
                                  )
                                  // Regular browser behavior - open in new tab
                                  e.preventDefault()
                                  if (typeof window !== "undefined") {
                                    window.open(navUrl, "_blank")
                                  }
                                }}
                              >
                                <Typography variant="body-sm">
                                  {displayText}
                                </Typography>
                              </a>
                            </li>
                          )
                        }
                      )}
                    </ul>
                  </li>
                </ul>
              )
            })}
          </div>
          <FooterBase footerNavCopy={footerNavCopy} />
        </div>
      </div>
    </footer>
  )
}
